// src\utils\sseService.ts
import axios from "axios";
import { ElMessage, ElNotification } from "element-plus";
import { EventSourcePolyfill } from "event-source-polyfill";
import { h } from "vue";
// 单例模式
export class SseService {
    static instance = null;
    eventSource = null;
    retryTimestamp = [];
    reconnectTimeout = 5000;
    saToken;
    // 私有构造函数，防止外部直接创建实例
    constructor(saToken) {
        this.saToken = saToken;
    }
    // 获取单例实例
    static getInstance(saToken) {
        if (!this.instance) {
            this.instance = new SseService(saToken);
        }
        return this.instance;
    }
    // 用于连接到 SSE 并接收数据
    connect() {
        // 检查用户是否登录
        if (localStorage.getItem("s") === "false") {
            console.info("未登录，无法连接到 SSE");
            return;
        }
        else {
            console.log("已登录,进行 SSE 连接...");
        }
        // 防止重复连接
        if (this.eventSource) {
            console.log("SSE 已经连接");
            return;
        }
        // 获取 token，确保有有效的 token
        const token = localStorage.getItem("sa") || "";
        if (!token) {
            console.error("没有有效的 saToken，无法建立连接");
            return;
        }
        // 创建 EventSource 实例
        console.log("SSE 实例创建..");
        this.eventSource = new EventSourcePolyfill("/api/notification/subscribe", {
            headers: {
                satoken: token,
            },
            heartbeatTimeout: 10 * 60 * 1000,
        });
        // 监听 init type
        this.eventSource.addEventListener("init", (event) => {
            const data = JSON.parse(event.data);
            // console.log("init消息", data);
            sendPutRequest(data.id, token);
            return;
            ElNotification({
                title: data.type,
                message: h("i", { style: "color: teal" }, data.content),
                duration: 0,
                type: "error",
                onClick: () => {
                    console.log("你好");
                    ElMessage.warning("后续为大家添加点击快捷出价");
                    ElMessage.info("按 ESC 清除消息");
                },
            });
        });
        // 初始连接事件
        this.eventSource.onopen = function (e) { };
        // 实时消息
        this.eventSource.onmessage = function (event) {
            const data = JSON.parse(event.data);
            ElNotification({
                title: data.type,
                message: h("i", { style: "color: teal" }, data.content),
                duration: 3000,
                type: "error",
                onClick: () => {
                    console.log("你好");
                    ElMessage.warning("后续为大家添加点击快捷出价");
                    ElMessage.info("2s过后自动清除,按 ESC 立即清除所有消息");
                },
                onClose: () => {
                    sendPutRequest(data.id, token);
                },
            });
            // store.dispatch("sse/updateSseMessage", data);
        };
        // 监听错误事件，尝试自动重连
        this.eventSource.onerror = (error) => {
            // console.error("SSE 连接错误:", error);
            this.reconnect();
        };
    }
    // 自动重连机制
    reconnect() {
        // console.log(`sse尝试重新连接...`);
        this.retryTimestamp.push(new Date());
        setTimeout(() => this.connect(), this.reconnectTimeout);
    }
    // 关闭连接
    close() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
            console.log("SSE 已关闭");
        }
    }
}
// 显示通知后标记为已读
// 封装 PUT 请求函数
async function sendPutRequest(id, satoken) {
    const headers = {
        satoken: satoken,
    };
    try {
        const response = await axios.put(`/api/notification/read?id=${id}`, {}, { headers });
        console.log("Response Data:", response.data);
        return response;
    }
    catch (error) {
        console.error("Error:", error);
        throw error; // 抛出错误以便外部捕获
    }
}
